<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Bulk Import Consent</v-card-title>

        <v-card-text>

            <p>
                To import customer consent, you should use the RedChirp consent import template (an excel file).  To download the template, <a href="https://files.redchirp.com/consent-import-v1.xlsx">click here</a>.
            </p>


            <p>
                The template includes detailed instructions and also has some examples of valid data.
            </p>

            <p>
                When you are ready, email your import to Angela Kane &mdash; <a href="mailto: angela.kane@redchirp.com">angela.kane@redchirp.com</a> for review and importing.
            </p>

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>